import WarningBannerApi from 'api-client/WarningBanner.api'
import StoreConnector from '@/helpers/StoreConnector'

const WarningBannerService = {
  async getActiveWarningBanners() {
    try {
      const result = await WarningBannerApi.getActiveWarningBanners()
      StoreConnector.dispatch('warningBanner/setWarningBanners', result)
      return Promise.resolve()
    } catch (e) {
      return Promise.resolve()
    }
  },
  getAllWarningBanners() {
    return WarningBannerApi.getAllWarningBanners()
  },
  createNewWarningBanner(payload) {
    return WarningBannerApi.createNewWarningBanner(payload)
  },
  updateWarningBanner(id, payload) {
    return WarningBannerApi.updateWarningBanner(id, payload)
  },
  deleteWarningBanner(id) {
    return WarningBannerApi.deleteWarningBanner(id)
  },
}

export default WarningBannerService
